/**
 * Format file size in bytes to human readable format
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 B";

  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};

/**
 * Get file extension from filename
 */
export const getFileExtension = (filename: string): string => {
  return filename.split(".").pop()?.toLowerCase() || "";
};

/**
 * Check if file type is previewable
 */
export const isPreviewable = (contentType: string): boolean => {
  const previewableTypes = [
    "image/",
    "text/",
    "application/pdf",
    "application/json",
  ];

  return previewableTypes.some((type) => contentType.startsWith(type));
};

/**
 * Get friendly name for content type
 */
export const getContentTypeLabel = (contentType: string): string => {
  const typeMap: Record<string, string> = {
    "application/pdf": "PDF",
    "application/msword": "Word",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
    "application/vnd.ms-excel": "Excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel",
    "application/vnd.ms-powerpoint": "PowerPoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PowerPoint",
    "application/zip": "ZIP",
    "application/x-rar-compressed": "RAR",
    "application/json": "JSON",
    "text/plain": "Texte",
    "text/csv": "CSV",
  };

  if (typeMap[contentType]) {
    return typeMap[contentType];
  }

  if (contentType.startsWith("image/")) {
    return "Image";
  }

  if (contentType.startsWith("video/")) {
    return "Vidéo";
  }

  if (contentType.startsWith("audio/")) {
    return "Audio";
  }

  return contentType.split("/")[1]?.toUpperCase() || "Fichier";
};

export const downloadFile = ({ resource, filename }: { resource: string | Blob, filename: string }): void => {
  const url = typeof resource === "string" ? resource : URL.createObjectURL(resource);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
